import { Injectable } from '@angular/core';
import { EntityState, EntityStore, ID, Query, QueryEntity, Store, StoreConfig } from '@datorama/akita';
import { Event } from '../model/event.model';
import { CourseEnrollment } from '../model/course-enrollment.model';
import { Observable } from 'rxjs/Rx';
import {Action} from "../model/action.model";


export interface ActionState extends EntityState<Action> {
	size: number;
	pageIndex: number;
	total: number;
	pageIds: ID[];
}

@StoreConfig({ name: 'action' })
export class ActionStore extends EntityStore<ActionState, Action> {

	upsertPage(events:Event[], size: number, pageIndex: number, total: number) {
		const eventIds = events
			.map(event => {
				this.upsert(event.id, event);
				return event.id;
			});

		this.updateRoot({
			size: size,
			pageIndex: pageIndex,
			total: total,
			pageIds: eventIds
		})
	}

	constructor() {
		super({size: 25, pageIndex: 0, total: 0, pageIds: []});
	}
}

@Injectable({providedIn: 'root'})
export class ActionQuery extends QueryEntity<ActionState, Action> {

	getPageIndex(): number {
		return this.getSnapshot().pageIndex;
	}

	getSize(): number {
		return this.getSnapshot().size;
	}

	getTotal(): number {
		return this.getSnapshot().total;
	}

	selectPageIndex(): Observable<number> {
		return this.select(state => state.pageIndex);
	}

	selectSize(): Observable<number> {
		return this.select(state => state.size);
	}

	selectTotal(): Observable<number> {
		return this.select(state => state.total)
	}

	selectPage(): Observable<Action[]>{
		return this.select(state => state.pageIds.map(id => this.getEntity(id)));
	}

	constructor(protected store: ActionStore) {
		super(store);
	}
}
